<template>
    <v-row class="mx-2 mt-3 mobile-header-menu">
        <v-col cols="4" class="ma-0 pa-0 pt-3">
            <logo-header />
        </v-col>
        <v-col
            cols="8"
            class="text-right ma-0 pa-0 pt-1"
        >
            <v-btn
                fab
                data-testid="hamburger-menu-button"
                class="hamburger-menu"
                height="50px"
                width="50px"
                @click="openMobileDialogMenu"
            >
                <v-icon color="white">
                    fas fa-bars
                </v-icon>
            </v-btn>
            <mobile-dialog-menu />
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import MobileDialogMenu from './MobileDialogMenu';
import LogoHeader from '@/components/bars/logoHeader/LogoHeader';

export default {
    name: 'mobile-header-menu',
    components: {
        MobileDialogMenu,
        LogoHeader,
    },
    computed: {
        ...mapGetters({
            getLogoUrl: 'getLogoUrl',
        }),
    },
    methods: {
        ...mapActions({
            setLocale: 'setLocale',
        }),
        ...mapMutations({
            setOpenMobileDialogMenu: 'mobileDialogMenu/SET_IS_OPEN',
        }),
        openMobileDialogMenu() {
            this.setOpenMobileDialogMenu(true);
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables';
.hamburger-menu{
    background-color: $cs-color-primary !important;
}

</style>
